module.exports = __webpack_public_path__ + "static/media/BM 01.b929989e.png";